import instance from "@/utils/require.js"

// 生产系统--线体
export function apiFactoryOrgShow(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization/show",
		method: "post",
		data
	})
}

// 生产系统--组装工单列表
export function apiProductionOrderList(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/list",
		method: "post",
		data
	})
}
export function apiSmtOrderList(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/list",
		method: "post",
		data
	})
}

// 生产系统--工单详情
export function apiProductionOrderDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/detail",
		method: "post",
		data
	})
}
export function apiSmtOrderDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/detail",
		method: "post",
		data
	})
}

// 生产系统--工序列表
export function apiProductionOrderSopList(data = {}) {
	return instance({
		url: "/aim/api/v3/production_order/sop/list",
		method: "post",
		data
	})
}

// 生产系统--工序列表
export function apiSmtOrderSopList(data = {}) {
	return instance({
		url: "/aim/api/v3/smt_order/sop/list",
		method: "post",
		data
	})
}

// 生产系统--绑定
export function apiWorkProcess(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/action",
		method: "post",
		data
	})
}

export function apiSqcVideo(data = {}) {
	return instance({
		url: "aim/api/v3/qc_order/sqc/video",
		method: "post",
		data
	})
}

// 生产系统--老化抽检--上架
export function apiSqcAgingOn(data = {}) {
	return instance({
		url: "aim/api/v3/qc_order/sqc/aging_on",
		method: "post",
		data
	})
}

// 生产系统--老化抽检--下架
export function apiSqcAgingOff(data = {}) {
	return instance({
		url: "aim/api/v3/qc_order/sqc/aging_off",
		method: "post",
		data
	})
}

export function apiAipcAfterRepairVisual(data = {}) {
	return instance({
		url: "aim/api/v3/aipc_repair/after_repair",
		method: "post",
		data
	})
}

export function apiAipcRenovateDisassemble(data = {}) {
	return instance({
		url: "aim/api/v3/aipc_repair/renovate_disassemble",
		method: "post",
		data
	})
}

export function apiReplacePartSnForce(data = {}) {
	return instance({
		url: "aim/api/v3/aipc_part/replace_part_sn_force",
		method: "post",
		data
	})
}

// 生产系统--配件类型枚举
export function apiPartTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/part_type",
		method: "post",
		data
	})
}